import { Store, ActionTypes, AuthenticatedUser, Permissions, Environment } from './types';

declare const _user: AuthenticatedUser;
declare const _permissions: Permissions;
declare const _environment: Environment;

export type State = {
    authenticatedUser: AuthenticatedUser;
    environment: Environment;
};

export default function rootReducer(state: Store, action: ActionTypes): State {
    if (!state) {
        const initState = {
            authenticatedUser: _user,
            environment: _environment,
        };
        // load data from global state on init
        initState.authenticatedUser.permissions = _permissions;
        return initState;
    }

    return state;
}
